// Lo que el siguiente mensaje del usuario le dice al bot sobre skills.
// Lo lee el store middleware de Web Chat (App.tsx) al publicar cada
// mensaje, igual que el botón Think (thinkingState.ts): fuera de React
// porque el middleware no tiene acceso al store de Redux de la app.
//
// - skill: la skill elegida en el menú "/" -> channelData.skill. El
//   bot la activa en ese turno como si se hubiera escrito su comando.
// - dropSkills: skills activas que el usuario quitó del área de texto
//   (× del chip) -> channelData.dropSkills. El bot las apaga antes de
//   empezar el turno.

let pendingSkill: string | null = null;
let dropSkills: string[] = [];

export const setPendingSkill = (name: string | null) => {
  pendingSkill = name;
};

export const queueDropSkill = (name: string) => {
  if (!dropSkills.includes(name)) dropSkills = [...dropSkills, name];
  if (pendingSkill === name) pendingSkill = null;
};

// La skill se borró (× de la sección Skills): si estaba elegida y sin
// enviar, ya no debe viajar en el siguiente mensaje.
export const forgetPendingSkill = (name: string) => {
  if (pendingSkill === name) pendingSkill = null;
};

export const resetSkillState = () => {
  pendingSkill = null;
  dropSkills = [];
};

// Devuelve el channelData de skills del mensaje y lo consume: cada
// selección o baja viaja una sola vez.
export const takeSkillChannelData = (): {
  skill?: string;
  dropSkills?: string[];
} => {
  const data: { skill?: string; dropSkills?: string[] } = {};
  if (pendingSkill) data.skill = pendingSkill;
  if (dropSkills.length) data.dropSkills = dropSkills;
  pendingSkill = null;
  dropSkills = [];
  return data;
};
